import { supabase } from './client';
import { getProfileById } from './profiles';

export interface UserActivity {
  id: string;
  user_id: string;
  activity_type: string;
  message: string;
  link: string | null;
  is_read: boolean;
  created_at: string;
  target_profile_id: string | null;
  target_profile_username: string | null;
}

export const logActivity = async (
  userId: string,
  activityType: string,
  message: string,
  link: string | null = null,
  targetProfileId: string | null = null
) => {
  let targetProfileUsername: string | null = null;
  if (targetProfileId) {
    const profile = await getProfileById(targetProfileId);
    targetProfileUsername = profile?.username || null;
  }

  const { data, error } = await supabase
    .from('user_activities')
    .insert({
      user_id: userId,
      activity_type: activityType,
      message: message,
      link: link,
      target_profile_id: targetProfileId,
      target_profile_username: targetProfileUsername,
    })
    .select()
    .single();

  if (error) {
    console.error('Error logging activity:', error);
    throw error;
  }
  return data;
};

export const getUserActivities = async (userId: string): Promise<UserActivity[]> => {
  const { data, error } = await supabase
    .from('user_activities')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching user activities:', error);
    throw error;
  }
  return data;
};